var map = {
	"./Loading/Loading": 31676,
	"./Loading/Loading.tsx": 31676,
	"./Loading/assets/apex-logo.png": 6639,
	"./Loading/assets/green-circle.svg": 31144,
	"./Loading/assets/half-green-circle.svg": 45949,
	"./NotFound/404": 28740,
	"./NotFound/404.tsx": 28740,
	"./NotFound/assets/404-logo.png": 55067,
	"./NotFound/assets/background.png": 5868,
	"./about/About": 65497,
	"./about/About.tsx": 65497,
	"./about/Block3CardData": 72845,
	"./about/Block3CardData.json": 72845,
	"./about/assets/Block1/anchor-bar.png": 62659,
	"./about/assets/Block1/background.png": 95167,
	"./about/assets/Block2/background.png": 29370,
	"./about/assets/Block2/logo-en.png": 52066,
	"./about/assets/Block2/logo-zh.png": 16137,
	"./about/assets/Block3/background-m.png": 90724,
	"./about/assets/Block3/background.png": 86686,
	"./about/assets/Block3/icon1.svg": 55358,
	"./about/assets/Block3/icon2.svg": 2203,
	"./about/assets/Block3/icon3.svg": 18394,
	"./about/assets/Block3/icon4.svg": 19215,
	"./about/assets/Block3/icon5.svg": 24684,
	"./about/assets/Block4/background.png": 14147,
	"./about/assets/Block4/section1.png": 53312,
	"./about/assets/Block4/section2.png": 61136,
	"./about/assets/Block5/background.png": 41286,
	"./about/assets/Block6/background.png": 11254,
	"./about/assets/Block6/section.png": 15307,
	"./about/component/Block1": 97638,
	"./about/component/Block1.tsx": 97638,
	"./about/component/Block2": 33227,
	"./about/component/Block2.tsx": 33227,
	"./about/component/Block3": 53331,
	"./about/component/Block3.tsx": 53331,
	"./about/component/Block4": 51228,
	"./about/component/Block4.tsx": 51228,
	"./about/component/Block5": 23986,
	"./about/component/Block5.tsx": 23986,
	"./about/component/Block6": 81622,
	"./about/component/Block6.tsx": 81622,
	"./antiFraud/AntiFraud": 17624,
	"./antiFraud/AntiFraud.tsx": 17624,
	"./antiFraud/assets/block1-background-notice.png": 88642,
	"./antiFraud/assets/block1-background.png": 9191,
	"./antiFraud/assets/block1-filter.png": 61535,
	"./antiFraud/component/Block1": 7317,
	"./antiFraud/component/Block1.tsx": 7317,
	"./antiFraud/component/Block2": 67539,
	"./antiFraud/component/Block2.tsx": 67539,
	"./contact/Contact": 80374,
	"./contact/Contact.tsx": 80374,
	"./contact/assets/block1-background-m.png": 40813,
	"./contact/assets/block1-background.png": 23141,
	"./contact/assets/block2-background-m.jpg": 90825,
	"./contact/assets/block2-background.jpg": 29983,
	"./contact/component/Block1": 8996,
	"./contact/component/Block1.tsx": 8996,
	"./contact/component/Block2": 52144,
	"./contact/component/Block2.tsx": 52144,
	"./esg/Block2CardData": 51163,
	"./esg/Block2CardData.json": 51163,
	"./esg/Block3CardData": 11554,
	"./esg/Block3CardData.json": 11554,
	"./esg/Block3ImageData": 72871,
	"./esg/Block3ImageData.json": 72871,
	"./esg/Block3PeopleRightData": 24587,
	"./esg/Block3PeopleRightData.json": 24587,
	"./esg/Block3VideoData": 55250,
	"./esg/Block3VideoData.json": 55250,
	"./esg/DownloadData": 85400,
	"./esg/DownloadData.json": 85400,
	"./esg/ESG": 56330,
	"./esg/ESG.tsx": 56330,
	"./esg/assets/Block1/anchor-bar.png": 49062,
	"./esg/assets/Block1/background.png": 33556,
	"./esg/assets/Block2/background.png": 80389,
	"./esg/assets/Block2/card1-img-en.png": 21212,
	"./esg/assets/Block2/card1-img-zh.png": 68958,
	"./esg/assets/Block2/card1-img.png": 23441,
	"./esg/assets/Block2/card2-img.png": 53147,
	"./esg/assets/Block2/card3-img.png": 15949,
	"./esg/assets/Block2/esg-pic-1-en.png": 94780,
	"./esg/assets/Block2/esg-pic-1-zh.png": 52028,
	"./esg/assets/Block2/esg-pic-2.png": 88665,
	"./esg/assets/Block2/esg-pic-3.png": 19881,
	"./esg/assets/Block2/esg-pic-4.png": 61020,
	"./esg/assets/Block2/esg-pic-7.png": 85758,
	"./esg/assets/Block2/green-line.png": 72854,
	"./esg/assets/Block2/logo.png": 65758,
	"./esg/assets/Block2/statement-en1.png": 258,
	"./esg/assets/Block2/statement-en2.png": 49358,
	"./esg/assets/Block2/statement-en3.png": 77097,
	"./esg/assets/Block2/statement-en4.png": 44042,
	"./esg/assets/Block2/statement-en5.png": 21236,
	"./esg/assets/Block2/statement-en6.png": 44284,
	"./esg/assets/Block2/statement1.png": 24482,
	"./esg/assets/Block2/statement2.png": 74179,
	"./esg/assets/Block2/statement3.png": 65987,
	"./esg/assets/Block2/statement4.png": 52296,
	"./esg/assets/Block2/statement5.png": 89448,
	"./esg/assets/Block3/background.png": 45517,
	"./esg/assets/Block3/esg-pic-1.png": 35630,
	"./esg/assets/Block3/orange-line.png": 77880,
	"./esg/assets/Block3/signature.png": 25054,
	"./esg/assets/Block3/slide-image-1.png": 36569,
	"./esg/assets/Block3/slide-image-2.png": 20463,
	"./esg/assets/Block3/slide-image-3.png": 29298,
	"./esg/assets/Block3/slide-image-4.png": 61651,
	"./esg/assets/Block3/slide-image-5.png": 36314,
	"./esg/assets/Block4/background.png": 47634,
	"./esg/assets/Block4/blue-line.png": 22799,
	"./esg/assets/Block4/esg-image1.png": 3784,
	"./esg/assets/Block4/esg-image2-mobile.png": 12835,
	"./esg/assets/Block4/esg-image2.png": 37343,
	"./esg/assets/Block4/esg-image3-mobile.png": 95174,
	"./esg/assets/Block4/esg-image3.png": 5474,
	"./esg/assets/Block4/esg-image4-mobile.png": 34962,
	"./esg/assets/Block4/esg-image4.png": 8663,
	"./esg/assets/Block5/grey-line.png": 227,
	"./esg/assets/Block5/icon-download.svg": 18666,
	"./esg/component/Block1": 27661,
	"./esg/component/Block1.tsx": 27661,
	"./esg/component/Block2": 36631,
	"./esg/component/Block2.tsx": 36631,
	"./esg/component/Block3": 62084,
	"./esg/component/Block3.tsx": 62084,
	"./esg/component/Block4": 47478,
	"./esg/component/Block4.tsx": 47478,
	"./esg/component/Block5": 83992,
	"./esg/component/Block5.tsx": 83992,
	"./harassment/DownloadData": 81618,
	"./harassment/DownloadData.json": 81618,
	"./harassment/Harassment": 55764,
	"./harassment/Harassment.tsx": 55764,
	"./harassment/assets/block1-background.png": 45626,
	"./harassment/assets/block1-filter.png": 64419,
	"./harassment/assets/block3-icon-download.svg": 94530,
	"./harassment/component/Block1": 62852,
	"./harassment/component/Block1.tsx": 62852,
	"./harassment/component/Block2": 33015,
	"./harassment/component/Block2.tsx": 33015,
	"./harassment/component/Block3": 36492,
	"./harassment/component/Block3.tsx": 36492,
	"./hiring/Hiring": 53377,
	"./hiring/Hiring.tsx": 53377,
	"./hiring/assets/Block1/background.png": 18623,
	"./hiring/assets/Block2/ceo.png": 4203,
	"./hiring/assets/Block2/factory-director.png": 50998,
	"./hiring/assets/Block2/frame.svg": 4799,
	"./hiring/assets/Block3/benefit1-1.png": 8840,
	"./hiring/assets/Block3/benefit1-2.png": 49419,
	"./hiring/assets/Block3/benefit1-3.png": 85999,
	"./hiring/assets/Block3/benefit1-4.png": 83679,
	"./hiring/assets/Block3/benefit1-5.png": 48624,
	"./hiring/assets/Block3/benefit1-6.png": 99087,
	"./hiring/assets/Block3/benefit1.png": 75091,
	"./hiring/assets/Block3/benefit2-1.png": 81688,
	"./hiring/assets/Block3/benefit2-2.png": 97265,
	"./hiring/assets/Block3/benefit2-3.png": 48142,
	"./hiring/assets/Block3/benefit2-4.png": 45901,
	"./hiring/assets/Block3/benefit2-5.png": 91573,
	"./hiring/assets/Block3/benefit2-6.png": 46331,
	"./hiring/assets/Block3/benefit2.png": 23973,
	"./hiring/assets/Block4/frame1.svg": 33759,
	"./hiring/assets/Block4/frame2.svg": 21980,
	"./hiring/assets/Block4/frame3.svg": 78896,
	"./hiring/assets/Block4/icon-production.svg": 39498,
	"./hiring/assets/Block4/icon-quality.svg": 56914,
	"./hiring/assets/Block4/icon-sales.svg": 79874,
	"./hiring/components/Block1": 17628,
	"./hiring/components/Block1.tsx": 17628,
	"./hiring/components/Block2": 39783,
	"./hiring/components/Block2.tsx": 39783,
	"./hiring/components/Block3": 60577,
	"./hiring/components/Block3.tsx": 60577,
	"./hiring/components/Block4": 18614,
	"./hiring/components/Block4.tsx": 18614,
	"./hiring/components/Block5": 42022,
	"./hiring/components/Block5.tsx": 42022,
	"./home/Block4SliderData": 83772,
	"./home/Block4SliderData.json": 83772,
	"./home/Home": 69114,
	"./home/Home.tsx": 69114,
	"./home/assets/Block1/Block1-background-video.mp4": 25926,
	"./home/assets/Block1/background.png": 3524,
	"./home/assets/Block2/arrow1.png": 45357,
	"./home/assets/Block2/arrow2.png": 64327,
	"./home/assets/Block2/arrow3.png": 90107,
	"./home/assets/Block2/background-mobile.png": 10069,
	"./home/assets/Block2/background.png": 86182,
	"./home/assets/Block3/background-mobile.png": 80695,
	"./home/assets/Block3/background.png": 97538,
	"./home/assets/Block3/card-icon-box.png": 8925,
	"./home/assets/Block3/card-icon-mrt.png": 93446,
	"./home/assets/Block3/card-icon-wind.png": 18457,
	"./home/assets/Block3/card-image-box.png": 51229,
	"./home/assets/Block3/card-image-mrt.png": 75525,
	"./home/assets/Block3/card-image-wind.png": 14605,
	"./home/assets/Block4/background-mobile.png": 2258,
	"./home/assets/Block4/background.png": 30982,
	"./home/assets/Block4/slide-logo1.png": 33911,
	"./home/assets/Block4/slide-logo2.png": 9519,
	"./home/assets/Block4/slide-logo3.png": 22035,
	"./home/assets/Block4/slide-logo4.png": 25967,
	"./home/assets/Block4/slide-logo5.png": 80386,
	"./home/assets/Block4/slide-logo6.png": 48629,
	"./home/assets/Block5/background-mobile.png": 19142,
	"./home/assets/Block5/background.png": 37061,
	"./home/assets/Block5/card-background-test.png": 29879,
	"./home/component/Block1": 70139,
	"./home/component/Block1.tsx": 70139,
	"./home/component/Block2": 56377,
	"./home/component/Block2.tsx": 56377,
	"./home/component/Block3": 12882,
	"./home/component/Block3.tsx": 12882,
	"./home/component/Block4": 65771,
	"./home/component/Block4.tsx": 65771,
	"./home/component/Block5": 11425,
	"./home/component/Block5.tsx": 11425,
	"./investor/Financial": 1636,
	"./investor/Financial.tsx": 1636,
	"./investor/Governance": 66369,
	"./investor/Governance.tsx": 66369,
	"./investor/assets/block1/anchor-bar.png": 28477,
	"./investor/assets/block1/block1-background-mobile.png": 38260,
	"./investor/assets/block1/block1-background.png": 82022,
	"./investor/assets/block2/companyStructure-en.png": 66796,
	"./investor/assets/block2/companyStructure-zh.png": 71738,
	"./investor/assets/block3/board1.png": 11816,
	"./investor/assets/block3/board2.png": 37944,
	"./investor/assets/block3/board3.png": 98296,
	"./investor/assets/block3/board4.png": 50841,
	"./investor/assets/block3/default.png": 8950,
	"./investor/assets/block5/blank.pdf": 22265,
	"./investor/assets/block5/icon-download.svg": 18116,
	"./investor/assets/financialBlock1/anchor-bar.png": 36627,
	"./investor/assets/financialBlock1/block1-background-mobile.png": 23922,
	"./investor/assets/financialBlock1/block1-background.png": 94257,
	"./investor/board": 93530,
	"./investor/board.ts": 93530,
	"./investor/component/Block1": 7408,
	"./investor/component/Block1.tsx": 7408,
	"./investor/component/Block2": 48788,
	"./investor/component/Block2.tsx": 48788,
	"./investor/component/Block3": 48757,
	"./investor/component/Block3.tsx": 48757,
	"./investor/component/Block4": 58076,
	"./investor/component/Block4.tsx": 58076,
	"./investor/component/Block5": 48951,
	"./investor/component/Block5.tsx": 48951,
	"./investor/component/ContentTable": 98786,
	"./investor/component/ContentTable.tsx": 98786,
	"./investor/component/FinancialBlock1": 2808,
	"./investor/component/FinancialBlock1.tsx": 2808,
	"./investor/component/FinancialBlock2": 62721,
	"./investor/component/FinancialBlock2.tsx": 62721,
	"./investor/component/FinancialBlock3": 41221,
	"./investor/component/FinancialBlock3.tsx": 41221,
	"./investor/component/FinancialBlock4": 88142,
	"./investor/component/FinancialBlock4.tsx": 88142,
	"./investor/downData": 9297,
	"./investor/downData.json": 9297,
	"./investor/financialPath": 44515,
	"./investor/financialPath.json": 44515,
	"./investor/path": 86897,
	"./investor/path.json": 86897,
	"./news/ArticleData": 6859,
	"./news/ArticleData.json": 6859,
	"./news/Block2ArticleData": 59027,
	"./news/Block2ArticleData.json": 59027,
	"./news/Block2SideBarData": 72923,
	"./news/Block2SideBarData.json": 72923,
	"./news/News": 2782,
	"./news/News.tsx": 2782,
	"./news/NewsDetail": 77524,
	"./news/NewsDetail.tsx": 77524,
	"./news/StructuredData": 38971,
	"./news/StructuredData.tsx": 38971,
	"./news/assets/article-banner.png": 98807,
	"./news/assets/article1.png": 84537,
	"./news/assets/article2.png": 38434,
	"./news/assets/article3.png": 97099,
	"./news/assets/article4.png": 38559,
	"./news/assets/article5.png": 62439,
	"./news/assets/articleDetail1.png": 76527,
	"./news/assets/articleDetail2.png": 72882,
	"./news/assets/articleDetail3.png": 76724,
	"./news/assets/block1-background-mobile.png": 56582,
	"./news/assets/block1-background.png": 10120,
	"./news/assets/defaultImage.png": 18090,
	"./news/assets/sideBar1.png": 72422,
	"./news/assets/sideBar2.png": 98269,
	"./news/assets/sideBar3.png": 21170,
	"./news/component/ArticleCard": 70998,
	"./news/component/ArticleCard.tsx": 70998,
	"./news/component/ArticleDetailBlock1": 23926,
	"./news/component/ArticleDetailBlock1.tsx": 23926,
	"./news/component/ArticleDetailBlock2": 99106,
	"./news/component/ArticleDetailBlock2.tsx": 99106,
	"./news/component/Block1": 6306,
	"./news/component/Block1.tsx": 6306,
	"./news/component/Block2": 54389,
	"./news/component/Block2.tsx": 54389,
	"./news/component/SideBar": 90185,
	"./news/component/SideBar.tsx": 90185,
	"./privacy/Privacy": 56519,
	"./privacy/Privacy.tsx": 56519,
	"./privacy/assets/block1-background.png": 44961,
	"./privacy/assets/block1-filter.png": 15799,
	"./privacy/component/Block1": 68557,
	"./privacy/component/Block1.tsx": 68557,
	"./privacy/component/Block2": 30672,
	"./privacy/component/Block2.tsx": 30672,
	"./service/Block2SliderData": 37742,
	"./service/Block2SliderData.json": 37742,
	"./service/Block3CardData": 86362,
	"./service/Block3CardData.json": 86362,
	"./service/Block3DrawerData": 40721,
	"./service/Block3DrawerData.json": 40721,
	"./service/Block4SliderData": 30155,
	"./service/Block4SliderData.json": 30155,
	"./service/Service": 31106,
	"./service/Service.tsx": 31106,
	"./service/assets/Block1/background.png": 54443,
	"./service/assets/Block2/background.png": 22958,
	"./service/assets/Block2/slide0-bg-little.png": 84049,
	"./service/assets/Block2/slide0-bg.png": 62218,
	"./service/assets/Block2/slide0-img.png": 27843,
	"./service/assets/Block2/slide1-bg-little.png": 79298,
	"./service/assets/Block2/slide1-bg.png": 86075,
	"./service/assets/Block2/slide1-img.png": 84264,
	"./service/assets/Block2/slide2-bg-little.png": 15108,
	"./service/assets/Block2/slide2-bg.png": 25467,
	"./service/assets/Block2/slide2-img.png": 79918,
	"./service/assets/Block2/slide3-bg-little.png": 46077,
	"./service/assets/Block2/slide3-bg.png": 14647,
	"./service/assets/Block2/slide3-img.png": 42703,
	"./service/assets/Block2/slide4-bg-little.png": 40132,
	"./service/assets/Block2/slide4-bg.png": 46734,
	"./service/assets/Block2/slide4-img.png": 2891,
	"./service/assets/Block2/slide5-bg-little.png": 89551,
	"./service/assets/Block2/slide5-bg.png": 29591,
	"./service/assets/Block2/slide5-img.png": 68068,
	"./service/assets/Block3/circle.svg": 51502,
	"./service/assets/Block3/drawer-background.png": 99044,
	"./service/assets/Block3/drawer0-img.png": 50427,
	"./service/assets/Block3/drawer1-img.png": 76570,
	"./service/assets/Block3/drawer2-img.png": 58242,
	"./service/assets/Block3/drawer3-img.png": 79736,
	"./service/assets/Block3/icon-close.svg": 42051,
	"./service/assets/Block3/inner-circle-border.svg": 10230,
	"./service/assets/Block3/outer-circle-border.svg": 10238,
	"./service/assets/Block3/slide0-bg.png": 86701,
	"./service/assets/Block3/slide1-bg.png": 49858,
	"./service/assets/Block3/slide2-bg.png": 93163,
	"./service/assets/Block3/slide3-bg.png": 83463,
	"./service/assets/Block4/background.png": 14758,
	"./service/assets/Block4/slide0-img.png": 7543,
	"./service/assets/Block4/slide1-img.png": 19158,
	"./service/assets/Block4/slide2-img.png": 88785,
	"./service/assets/Block5/ISO-14001.png": 86398,
	"./service/assets/Block5/ISO-27001.svg": 2010,
	"./service/assets/Block5/ISO-3834.png": 68443,
	"./service/assets/Block5/ISO-45001.png": 55944,
	"./service/assets/Block5/ISO-50001.png": 65992,
	"./service/assets/Block5/ISO-9001.png": 75829,
	"./service/assets/Block5/ISO-EN1090.png": 42106,
	"./service/assets/Block5/ISO-bg-little.png": 28227,
	"./service/assets/Block5/ISO-bg.png": 40771,
	"./service/assets/Block5/lottie/data_en_us": 53705,
	"./service/assets/Block5/lottie/data_en_us.json": 53705,
	"./service/assets/Block5/lottie/data_zh_tw": 81774,
	"./service/assets/Block5/lottie/data_zh_tw.json": 81774,
	"./service/assets/Block6/flag.png": 17411,
	"./service/assets/Block6/focus-flag.png": 86735,
	"./service/assets/Block7/business-executives.png": 97302,
	"./service/assets/Block7/ceo.png": 94124,
	"./service/assets/Block7/default-avatar.png": 73262,
	"./service/assets/Block7/deputy-director.png": 66073,
	"./service/assets/Block7/factory-director.png": 28272,
	"./service/assets/Block8/ISO-50001.png": 46251,
	"./service/assets/Block8/ISO_14001_2015.png": 28999,
	"./service/assets/Block8/ISO_14001_2018.png": 19866,
	"./service/assets/Block8/ISO_14064_1.png": 61734,
	"./service/assets/Block8/ISO_9001_2015.png": 60673,
	"./service/assets/Block8/tech1.svg": 37089,
	"./service/assets/Block8/tech2.svg": 94796,
	"./service/assets/Block8/tech3.svg": 33754,
	"./service/assets/Block8/tech4.svg": 46406,
	"./service/component/Block1": 41613,
	"./service/component/Block1.tsx": 41613,
	"./service/component/Block2": 18098,
	"./service/component/Block2.tsx": 18098,
	"./service/component/Block3": 69045,
	"./service/component/Block3.tsx": 69045,
	"./service/component/Block4": 6697,
	"./service/component/Block4.tsx": 6697,
	"./service/component/Block5": 93839,
	"./service/component/Block5.tsx": 93839,
	"./service/component/Block6": 76640,
	"./service/component/Block6.tsx": 76640,
	"./service/component/Block7": 37475,
	"./service/component/Block7.tsx": 37475,
	"./service/component/Block8": 97343,
	"./service/component/Block8.tsx": 97343,
	"./service/data": 48276,
	"./service/data.json": 48276,
	"./user/Login": 90768,
	"./user/Login.tsx": 90768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32150;